var _circle, _path, _path2, _path3, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLotr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#7a6c33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 10c-4 0-9 3-9 10v4c0 1 0 6 9 12 9-6 9-11 9-12v-4c0-7-5-10-9-10z",
    fill: "#d4af37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16c-2 0-5 2-5 7v2s0 2 5 7c5-5 5-7 5-7v-2c0-5-3-7-5-7z",
    fill: "#7a6c33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22h6v4h-6z",
    fill: "#7a6c33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13c0 0-4 7-4 13 0 5 4 8 6 9-8-5-8-9-8-9v-4c0-6 6-9 6-9zm4 0c0 0 4 7 4 13 0 5-4 8-6 9 8-5 8-9 8-9v-4c0-6-6-9-6-9z",
    fill: "#fff",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 14,
    r: 1,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotr);
export default __webpack_public_path__ + "static/media/lotr.25d4b8a99f248dbf89152fa570a297fb.svg";
export { ForwardRef as ReactComponent };